var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.9 2.51997L12.87 2.58997L9.96995 9.31997H7.11995C6.43995 9.31997 5.79995 9.44997 5.19995 9.70997L6.94995 5.52997L6.98995 5.43997L7.04995 5.27997C7.07995 5.20997 7.09995 5.14997 7.12995 5.09997C8.43995 2.06997 9.91995 1.37997 12.9 2.51997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 9.52002C17.84 9.39002 17.37 9.32002 16.88 9.32002H9.96997L12.87 2.59002L12.9 2.52002C13.04 2.57002 13.19 2.64002 13.34 2.69002L15.55 3.62002C16.78 4.13002 17.64 4.66002 18.17 5.30002C18.26 5.42002 18.34 5.53002 18.42 5.66002C18.51 5.80002 18.58 5.94002 18.62 6.09002C18.66 6.18002 18.69 6.26002 18.71 6.35002C18.97 7.20002 18.81 8.23002 18.29 9.52002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.76 14.1999V16.1499C21.76 16.3499 21.75 16.5499 21.74 16.7399C21.55 20.2399 19.6 21.9999 15.9 21.9999H8.09999C7.84999 21.9999 7.61999 21.9799 7.38999 21.9499C4.20999 21.7399 2.50999 20.0399 2.28999 16.8599C2.25999 16.6199 2.23999 16.3899 2.23999 16.1499V14.1999C2.23999 12.1899 3.45999 10.4599 5.19999 9.70995C5.79999 9.44995 6.43999 9.31995 7.11999 9.31995H16.88C17.37 9.31995 17.84 9.38995 18.29 9.51995C20.29 10.1299 21.76 11.9899 21.76 14.1999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.94999 5.53003L5.19999 9.71003C3.45999 10.46 2.23999 12.19 2.23999 14.2V11.27C2.23999 8.43003 4.25999 6.06003 6.94999 5.53003Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21.76 11.27V14.2C21.76 11.99 20.29 10.13 18.29 9.51997C18.81 8.22997 18.97 7.19997 18.71 6.34997C18.69 6.25997 18.66 6.17997 18.62 6.08997C20.49 7.05997 21.76 9.02997 21.76 11.27Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.69H12.75V13C12.75 12.59 12.41 12.25 12 12.25C11.59 12.25 11.25 12.59 11.25 13V14.69H9.5C9.09 14.69 8.75 15.03 8.75 15.44C8.75 15.85 9.09 16.19 9.5 16.19H11.25V18C11.25 18.41 11.59 18.75 12 18.75C12.41 18.75 12.75 18.41 12.75 18V16.19H14.5C14.91 16.19 15.25 15.85 15.25 15.44C15.25 15.03 14.91 14.69 14.5 14.69Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd);
export default __webpack_public_path__ + "static/media/wallet-add.35b3224794a39d9867e356cbfd12b8d8.svg";
export { ForwardRef as ReactComponent };